"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpProtocolOptions = void 0;
exports.HttpProtocolOptions = {
    HTTP: 'http://',
    HTTPS: 'https://',
};
